import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';
import { NavLink } from 'react-router-dom';

const SidebarLink = ({
  title, icon, beta, route, onClick, disableActive, upgrade, isNew
}) => (
  <NavLink
    exact
    to={route}
    onClick={onClick}
    activeClassName={ !disableActive && "sidebar__link-active" }
  >
    <li className={`sidebar__link ${upgrade ? "upgrade" : ""}`}>
      {icon ? <span className={`sidebar__link-icon lnr lnr-${icon}`} /> : ''}
      <p className="sidebar__link-title">
        {title}
        {beta && <Badge className="sidebar__link-badge"><span>Beta</span></Badge>}
        {isNew && <Badge className="sidebar__link-badge"><span>New</span></Badge>}
        {upgrade && <Badge className="sidebar__link-badge" style={{width:50,border:'1px solid #ff4861', color:'#ff4861', background:'#FFF',padding:4,height:18,borderRadius:10,top:-2}}><span>Upgrade</span></Badge>}
        {false && <Badge className="sidebar__link-badge upgrade__link"><span>Upgrade</span></Badge>}
      </p>
    </li>
  </NavLink>
);

SidebarLink.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  newLink: PropTypes.bool,
  route: PropTypes.string,
  onClick: PropTypes.func,
};

SidebarLink.defaultProps = {
  icon: '',
  newLink: false,
  route: '/',
  onClick: () => {},
};

export default SidebarLink;